module.exports = "https://web-assets.ifttt.com/packs/media/press/nyt-077512ca.svg";